import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: "search-bar-wrap",
    style: _normalizeStyle({ width: _ctx.width })
  }, [
    _createVNode(_component_el_input, {
      placeholder: _ctx.searchPlaceholder,
      modelValue: _ctx.inputVal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputVal) = $event)),
      onInput: _ctx.onInput,
      onChange: _ctx.doSearchFn,
      onBlur: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      clearable: ""
    }, {
      append: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_icon, { class: "element_icon hover_opacity" }, {
            default: _withCtx(() => [
              _createVNode(_component_Search)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["placeholder", "modelValue", "onInput", "onChange"])
  ], 4))
}